var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 66,
    viewBox: "0 0 53 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"page edit\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.4776 32.9383V13.5973C48.4776 13.105 48.2941 12.6328 47.9673 12.2847L38.821 2.54371C38.4942 2.19556 38.051 2 37.5888 2H3.74291C2.78033 2 2 2.83109 2 3.8563V62.0203C2 63.0456 2.78033 63.8766 3.74291 63.8766H22.334",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6194 26.7506H36.8582M13.6194 14.3753H25.2388M13.6194 39.1259H22.334",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.5346 48.2199L45.4395 45.1261C46.7115 43.7713 48.7739 43.7713 50.046 45.1261C51.318 46.4809 51.318 48.6775 50.046 50.0323L47.1411 53.1261M42.5346 48.2199L33.8459 57.4739C33.4105 57.9376 33.1246 58.5369 33.0299 59.1847L32.3249 64L36.8457 63.2494C37.4543 63.1482 38.0167 62.8438 38.4521 62.38L47.1411 53.1261M42.5346 48.2199L47.1411 53.1261",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.8582 2V12.519C36.8582 13.5442 37.6385 14.3753 38.6012 14.3753H48.4777",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageEditIcon);
export default __webpack_public_path__ + "static/media/page-edit-icon.087aaf7079e1f19d2efc7b6e387184b2.svg";
export { ForwardRef as ReactComponent };